import { NavLink, Outlet, Link } from "react-router-dom";
import { LayoutDashboard, Package, ShoppingCart, Landmark, Users, Settings, Store, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { Logo } from "@/components/store/Header";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { PasswordForm } from "@/pages/admin/AdminSettings";

const LINKS = [
  { to: "/yonetim", end: true, label: "Özet", icon: LayoutDashboard, id: "dashboard" },
  { to: "/yonetim/urunler", label: "Ürün Yönetimi", icon: Package, id: "products" },
  { to: "/yonetim/siparisler", label: "Siparişler", icon: ShoppingCart, id: "orders" },
  { to: "/yonetim/odemeler", label: "Gelen Ödemeler", icon: Landmark, id: "payments" },
  { to: "/yonetim/musteriler", label: "Müşteriler & Sepet", icon: Users, id: "customers" },
  { to: "/yonetim/ayarlar", label: "Ayarlar", icon: Settings, id: "settings" },
];

export default function AdminLayout() {
  const { user, setUser, signOut } = useAuth();
  const cls = ({ isActive }) =>
    `flex items-center gap-3 px-4 py-2.5 rounded-md text-sm font-semibold whitespace-nowrap transition-colors ${isActive ? "bg-white text-[#172554]" : "text-blue-100 hover:bg-white/10"}`;
  return (
    <div className="min-h-screen bg-[#F3F4F6] lg:flex">
      <aside className="lg:w-64 lg:min-h-screen bg-[#172554] lg:sticky lg:top-0 lg:h-screen flex flex-col">
        <div className="px-4 py-4 lg:py-6 flex items-center justify-between">
          <Link to="/" className="[&>span]:!text-[22px]"><Logo light /></Link>
        </div>
        <nav className="flex lg:flex-col gap-1 px-3 pb-3 overflow-x-auto no-scrollbar snap-x" data-testid="admin-nav">
          {LINKS.map(({ to, end, label, icon: Icon, id }) => (
            <NavLink key={to} to={to} end={end} className={cls} data-testid={`admin-nav-${id}`}>
              <Icon className="h-4 w-4" /> {label}
            </NavLink>
          ))}
          <Link to="/" className="flex items-center gap-3 px-4 py-2.5 rounded-md text-sm font-semibold text-blue-100 hover:bg-white/10 whitespace-nowrap" data-testid="admin-nav-store"><Store className="h-4 w-4" /> Mağazayı Gör</Link>
          <button onClick={signOut} className="flex items-center gap-3 px-4 py-2.5 rounded-md text-sm font-semibold text-blue-100 hover:bg-white/10 whitespace-nowrap" data-testid="admin-logout"><LogOut className="h-4 w-4" /> Çıkış</button>
        </nav>
      </aside>
      <main className="flex-1 min-w-0 p-4 sm:p-6 lg:p-8">
        <Outlet />
      </main>
      <Dialog open={!!user?.must_change_password}>
        <DialogContent data-testid="force-password-dialog" className="max-w-md [&>button]:hidden" onInteractOutside={(e) => e.preventDefault()}>
          <DialogHeader>
            <DialogTitle>Yeni şifrenizi belirleyin</DialogTitle>
            <DialogDescription>Size verilen geçici şifreyi mevcut şifre olarak yazın ve kendi şifrenizi oluşturun.</DialogDescription>
          </DialogHeader>
          <PasswordForm onDone={() => setUser({ ...user, must_change_password: false })} />
        </DialogContent>
      </Dialog>
    </div>
  );
}

export const PageTitle = ({ title, desc, children }) => (
  <div className="flex flex-wrap items-end justify-between gap-3 mb-6">
    <div>
      <h1 className="text-2xl sm:text-3xl font-bold text-[#172554]">{title}</h1>
      {desc && <p className="text-sm text-slate-600 mt-1">{desc}</p>}
    </div>
    <div className="flex gap-2 flex-wrap">{children}</div>
  </div>
);
